/**
 * Une las partidas de elaboración de todos los roles del venue sin duplicar por id.
 * @param {Array<{ elaborationStations?: Array<{ id: unknown; name?: string }> }>} roles
 * @returns {Array<{ id: unknown; name?: string }>}
 */
export function collectUniqueElaborationStations(roles) {
	if (!Array.isArray(roles)) {
		return [];
	}

	const byId = new Map();

	for (const role of roles) {
		for (const station of role?.elaborationStations || []) {
			if (station?.id == null) {
				continue;
			}
			const key = String(station.id);
			if (!byId.has(key)) {
				byId.set(key, station);
			}
		}
	}

	return Array.from(byId.values());
}
